export default "__VITE_ASSET__DXSlFIUn__"